<template>
  <main class="container d-flex justify-content-center">
    <div class="article">
      <div class="return-url">
        <router-link to="/" class="test">Vorige</router-link>
      </div>

      <h1><strong>Resultaat</strong></h1>
      <p>Hieronder vindt u de uitslag van de door u ingevulde velden.</p>

      <div class="result">
        <template v-if="leeftijd < 5 || leeftijd >= 18">
          <p>
            Uw kind is {{ leeftijd }} jaar. Deze rekentool is alleen bedoeld
            voor de naamswijziging van kinderen ouder dan 5 en jonger dan 18
            jaar. <br />NB: een Naamswijziging voor kinderen jonger dan 5 jaar
            is niet mogelijk.
          </p>
        </template>

        <template v-if="leeftijd >= 12 && leeftijd < 18">
          <p>
            Uw kind is {{ leeftijd }} jaar. <br />De vereiste minimale
            verzorgingstermijn voor de leeftijd van het kind is 3 jaar.
          </p>
          <template v-if="verzorgingstermijn >= 3">
            <p>
              Op basis van de door u ingevulde gegevens is een naamswijziging
              mogelijk. De uitkomst van de aanvraag is afhankelijk van de
              belangenafweging van het ministerie van Justitie en Veiligheid.
            </p>
            <p>
              Toelichting:<br />
              Voor naamswijziging van een kind geldt een verplichte
              verzorgingstermijn. Voor kinderen tussen 12 en 18 is een
              verzorgingstermijn van 3 jaar vereist. Deze termijn wordt berekend
              vanaf de ontbinding van het huwelijk of het verbreken van de
              buitenhuwelijkse samenleving met de andere ouder, tot de datum
              waarop de aanvraag wordt ingediend. Deze termijn moet onafgebroken
              zijn en direct voorafgaan aan de aanvraag. Indien aan de
              verzorgingstermijn wordt voldaan en de andere ouder stemt niet in,
              dan wordt de naamswijziging toegewezen als het kind bij zijn
              instemming blijft.
            </p>
          </template>
          <template v-if="verzorgingstermijn < 3">
            <p>
              Op basis van de door u ingevulde gegevens is de verzorgingstermijn
              minder dan 3 jaar en is naamswijziging niet mogelijk.
            </p>
            <p>
              Toelichting:<br />
              Voor naamswijziging van een kind geldt een verplichte
              verzorgingstermijn. Voor kinderen tussen 12 en 18 is een
              verzorgingstermijn van 3 jaar vereist. Deze termijn wordt berekend
              vanaf de ontbinding van het huwelijk of het verbreken van de
              buitenhuwelijkse samenleving met de andere ouder, tot de datum
              waarop de aanvraag wordt ingediend. Deze termijn moet onafgebroken
              zijn en direct voorafgaan aan de aanvraag. Indien aan de
              verzorgingstermijn wordt voldaan en de andere ouder stemt niet in,
              dan wordt de naamswijziging toegewezen als het kind bij zijn
              instemming blijft.
            </p>
          </template>
        </template>

        <template v-if="leeftijd >= 5 && leeftijd < 12">
          <p>
            Uw kind is {{ leeftijd }} jaar. <br />De vereiste minimale
            verzorgingstermijn voor de leeftijd van het kind is 5 jaar.
          </p>
          <template v-if="verzorgingstermijn < 5">
            <p>
              Op basis van de door u ingevulde gegevens is de verzorgingstermijn
              minder dan 5 jaar en is naamswijziging niet mogelijk.
            </p>
            <p>
              Toelichting:<br />
              Voor naamswijziging van een kind geldt een verplichte
              verzorgingstermijn. Voor kinderen jonger dan 12 is een
              verzorgingstermijn van 5 jaar vereist. Deze termijn wordt berekend
              vanaf de ontbinding van het huwelijk of het verbreken van de
              buitenhuwelijkse samenleving met de andere ouder, tot de datum
              waarop de aanvraag wordt ingediend. Deze termijn moet onafgebroken
              zijn en direct voorafgaan aan de aanvraag.
              <br /><br />Als niet aan de hoofdvoorwaarde van vijf jaar
              verzorgingstermijn wordt voldaan, kan de aanvraag niet worden
              toegewezen.
            </p>
          </template>
          <template v-if="verzorgingstermijn >= 5">
            <p>
              ¼ van de periode voorafgaand aan de verplichte verzorgingstermijn
              is {{ kwartPeriodeGezinsverband }} dagen.
            </p>
            <p>
              U heeft uw kind {{ dagenGezamenlijkeOpvoeding }} dagen gezamenlijk
              met de andere ouder opgevoed. Dit is
              {{ percentageGezamenlijkGeleefd }}% van de periode voorafgaand aan
              de verplichte verzorgingstermijn.
            </p>
            <template v-if="percentageGezamenlijkGeleefd < 25">
              <p>
                Op basis van de door u ingevulde gegevens is naamswijziging
                mogelijk. De uitkomst van de aanvraag is afhankelijk van de
                belangenafweging van het ministerie van Justitie en Veiligheid.
              </p>
              <p>
                Toelichting:<br />
                Voor naamswijziging van een kind geldt een verplichte
                verzorgingstermijn. Voor kinderen jonger dan 12 is een
                verzorgingstermijn van 5 jaar vereist. Deze termijn wordt
                berekend vanaf de ontbinding van het huwelijk of het verbreken
                van de buitenhuwelijkse samenleving met de andere ouder, tot de
                datum waarop de aanvraag wordt ingediend. Deze termijn moet
                onafgebroken zijn en direct voorafgaan aan de aanvraag.
                <br /><br />Als aan de hoofdvoorwaarde van vijf jaar
                verzorgingstermijn wordt voldaan maar de andere ouder niet
                instemt, kan de aanvraag niet worden toegewezen. Hierop bestaat
                een uitzondering: u toont aan dat de andere ouder niet of
                nauwelijks met het kind in gezinsverband heeft samengeleefd. Dat
                wil zeggen: niet langer dan een kwart van de periode voorafgaand
                aan de verzorgingstermijn van vijf jaar. Als hieraan wordt
                voldaan, dan beoordeelt Justis of naamswijziging in het belang
                is van het kind.
              </p>
            </template>
            <template v-if="percentageGezamenlijkGeleefd >= 25">
              <p>
                Op basis van de door u ingevulde gegevens is naamswijziging niet
                mogelijk.
              </p>
              <p>
                Toelichting:<br />
                Voor de naamswijziging van een kind geldt een verplichte
                verzorgingstermijn. Voor kinderen jonger dan 12 is een
                verzorgingstermijn van 5 jaar vereist. Deze termijn wordt
                berekend vanaf de ontbinding van het huwelijk of het verbreken
                van de buitenhuwelijkse samenleving met de andere ouder, tot de
                datum waarop de aanvraag wordt ingediend. Deze termijn moet
                onafgebroken zijn en direct voorafgaan aan de aanvraag.
                <br /><br />Als aan de hoofdvoorwaarde van vijf jaar
                verzorgingstermijn wordt voldaan maar de andere ouder niet
                instemt, kan de aanvraag niet worden toegewezen. Hierop bestaat
                een uitzondering: u toont aan dat de andere ouder niet of
                nauwelijks met het kind in gezinsverband heeft samengeleefd. Dat
                wil zeggen: niet langer dan een kwart van de periode voorafgaand
                aan de verzorgingstermijn van vijf jaar. Als hieraan wordt
                voldaan, dan beoordeelt Justis of naamswijziging in het belang
                is van het kind.
              </p>
            </template>
          </template>
        </template>
      </div>

      <disclaimer></disclaimer>
    </div>
  </main>
</template>

<script>
function roundDown(num, precision) {
  precision = Math.pow(10, precision);
  return Math.floor(num * precision) / precision;
}

var moment = require("moment");

import state from "../state.js";
import disclaimer from "../components/disclaimer.vue";

export default {
  components: { disclaimer },
  data() {
    return {
      data: state.form
    };
  },
  computed: {
    leeftijd() {
      let datumAanvraag = moment(this.data.datum_aanvraag, "DD-MM-YYYY");
      let geboortedatum = moment(this.data.geboortedatum, "DD-MM-YYYY");
      let leeftijd =
        datumAanvraag.diff(geboortedatum, "years", true) + 0.0000001; // Add small number to account for bug where an exact year difference gets rounded down

      return Math.floor(leeftijd);
    },
    dagenGezamenlijkeOpvoeding() {
      let datumEinde = moment(this.data.datum_einde, "DD-MM-YYYY");
      let datumAanvang = moment(this.data.datum_aanvang, "DD-MM-YYYY");
      let dagenGezamenlijkeOpvoeding = datumEinde.diff(datumAanvang, "days");
      return dagenGezamenlijkeOpvoeding;
    },
    eerstePeriodeInDagen() {
      let geboortedatum = moment(this.data.geboortedatum, "DD-MM-YYYY");
      let datumAanvraag = moment(this.data.datum_aanvraag, "DD-MM-YYYY");
      let datumAanvraagMinVijfJaar = datumAanvraag.subtract(5, "years");

      let eerstePeriodeInDagen = datumAanvraagMinVijfJaar.diff(
        geboortedatum,
        "days"
      );

      return eerstePeriodeInDagen;
    },
    percentageGezamenlijkGeleefd() {
      let result =
        (this.dagenGezamenlijkeOpvoeding / this.eerstePeriodeInDagen) * 100;
      return roundDown(result, 2);
    },
    kwartPeriodeGezinsverband() {
      return this.eerstePeriodeInDagen / 4.0;
    },
    verzorgingstermijn() {
      let datumAanvraag = moment(this.data.datum_aanvraag, "DD-MM-YYYY");
      let datumEinde = moment(this.data.datum_einde, "DD-MM-YYYY");
      let verzorginstermijn = datumAanvraag.diff(datumEinde, "years");
      console.log(verzorginstermijn);
      return verzorginstermijn;
    }
  }
};
</script>

<style lang="scss">
@import "../_common.scss";

.article {
  margin-bottom: 100px;
}

.result {
  margin-left: -8px;
  padding: 24px;
  background-color: dji-color(paars, 3);
}

@media screen and (max-device-width: 768px) {
  .result {
    margin-left: -24px;
    margin-right: -24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/result.vue